import { LineSegments, Object3D, Scene } from "three";
import {
  OBJECT_COLLISION_HITS,
  type NarrowHit,
  type ObjectCollisionHitsDetail,
} from "../designer/ObjectCollisionHits";
import { Engine } from "../engine/Engine";
import {
  createObbWireframeHelper,
} from "../util/GeometryUtil";
import { isDragCollisionDebugEnabled } from "../util/DebugFlags";

let _group: Object3D | null = null;

export function disposeObbDebugGroup(group: Object3D): void {
  group.traverse((obj) => {
    const ls = obj as LineSegments;
    if (!ls.isLineSegments) return;
    ls.geometry.dispose();
    const m = ls.material;
    if (Array.isArray(m)) m.forEach((x) => x.dispose());
    else m.dispose();
  });
  group.removeFromParent();
}


export function clearDragCollisionDebugDraw(): void {
  if (_group) {
    disposeObbDebugGroup(_group);
    _group = null;
  }
}

/** Tel kutu çizimi; `bindDragCollisionDebugToEngine` varsayılan dinleyicide kullanılır. */
export function syncDragCollisionDebugDraw(
  hits: NarrowHit[],
  scene: Scene | undefined,
): void {
  clearDragCollisionDebugDraw();
  if (!scene || hits.length === 0) return;

  const group = new Object3D();
  group.name = "collisionDebugGroup";
  for (const h of hits) {
    group.add(createObbWireframeHelper(h.selfObb.clone(), 0xff2222));
    group.add(
      createObbWireframeHelper(
        h.obstacle.obb.clone(),
        h.obstacle.kind === "wall" ? 0xffaa00 : 0xff4444,
      ),
    );
  }
  if (group.children.length === 0) return;

  scene.add(group);
  _group = group;
}

function onObjectCollisionHitsEvent(e: Event): void {
  const detail = (e as CustomEvent<ObjectCollisionHitsDetail>).detail;
  if (!detail || !isDragCollisionDebugEnabled() || detail.hits.length === 0) {
    clearDragCollisionDebugDraw();
    return;
  }
  syncDragCollisionDebugDraw(detail.hits, detail.scene);
}

/** Room designer: `?debugCollision=1` iken tel kutu. Kendi dinleyicini eklemek için önce bunu çağırma. */
export function bindDragCollisionDebugToEngine(engine: Engine): void {
  engine.addEventListener(OBJECT_COLLISION_HITS, onObjectCollisionHitsEvent);
}
